<style lang="scss">
  .ls-dialog {

    &__msg {
      display: flex;
      line-height: 24px;
    }

    .el-checkbox__label {
      font-size: 12px;
    }

    .el-dialog {
      &__header {
        padding: 0 20px;
        background-color: #f8f8f8;
      }

      &__headerbtn {
        top: 8px;
      }

      &__title {
        font-size: 13px;
        line-height: 30px;
      }

      &__body {
        display: flex;
        flex-direction: column;
        max-height: 500px;
        overflow-y: auto;
        padding: 20px 20px 0 20px;
        font-size: 12px;
        .icon {
          padding-right: 10px;
          font-size: 24px;
        }

        .info {
          color: #e6a23c;
        }
      }

      &__footer {
        margin-top: 20px;
        padding: 10px;
        text-align: center;
        background-color: #f8f8f8;
      }
    }

    .ls-admin-table-block {
      margin: 0;
      padding: 0;
    }
  }
</style>
<template>
  <el-dialog class="ls-dialog" v-dialogDrag :visible.sync="show" :title="title"
             :close-on-click-modal="closeOnClickModal" :before-close="close"
             :close-on-press-escape="false" :append-to-body="true" :width="width">
    <slot>{{content}}</slot>
    <span slot="footer" v-show="!hideFooter">
      <slot name="footer">
        <el-button size="mini" class="btn-solid-blue" @click="$emit('save')" icon="el-icon-check" :loading="loading">{{sureTxt}}</el-button>
        <el-button size="mini" v-show="!hideCancel" class="btn-red" style="margin-left: 25px;"
                   @click="cancel" :icon="cancelIcon">{{cancelTxt}}</el-button>
      </slot>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      // 是否隐藏底部按钮
      hideFooter: {
        type: Boolean,
        default: false
      },
      hideCancel: {
        type: Boolean,
        default: false
      },
      // 确定按钮文案
      sureTxt: {
        type: String,
        default: '确定'
      },
      // 取消按钮文案
      cancelTxt: {
        type: String,
        default: '取消'
      },
      cancelIcon: {
        type: String,
        default: 'el-icon-close'
      },
      //内部文本域
      content: {},
      // 如传true，会emit('cancel')
      isCancelEvent: {
        type: Boolean,
        default: false
      },
      // 按钮是否在加载中
      loading: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: '680px'
      },
      show: {
        type: Boolean,
        default: false
      },
      closeOnClickModal: {
        type: Boolean,
        default: false
      },
      top: {
        type: String,
        default: '15vh'
      },
    },
    methods: {
      close() {
        this.$emit('update:show', false);
      },
      cancel() {
        if (this.isCancelEvent) {
          this.$emit('cancel')
        } else {
          this.close()
        }
      },
    }
  }
</script>